// app/javascript/scenes_editor/tools_manager.js

export function initTools(controller) {
  // tools disponibili (da Scene -> Toolboxes -> Tools)
  controller.availableTools = controller.availableToolsValue || []

  // selezioni tools per hotspot
  controller.selectedToolIdsByHotspotId = new Map()

  // init da pulse_tool_ids già presenti nei dati hotspotsValue
  try {
    ;(controller.hotspots || []).forEach((hs) => {
      const raw = hs?.pulse_tool_ids

      let ids = []
      if (Array.isArray(raw)) {
        ids = raw
      } else if (raw == null) {
        ids = []
      } else if (typeof raw === "string") {
        try {
          const parsed = JSON.parse(raw)
          ids = Array.isArray(parsed) ? parsed : []
        } catch (_) {
          ids = raw.split(",").map((x) => x.trim()).filter(Boolean)
        }
      } else {
        ids = []
      }

      controller.selectedToolIdsByHotspotId.set(hs.id, new Set(ids.map(String)))
    })
  } catch (err) {
    console.warn("[EDITOR] init pulse_tool_ids skipped:", err)
  }
}

export function ensureToolsSetForHotspot(controller, hsId) {
  if (!controller.selectedToolIdsByHotspotId.has(hsId)) {
    controller.selectedToolIdsByHotspotId.set(hsId, new Set())
  }
  return controller.selectedToolIdsByHotspotId.get(hsId)
}

export function renderToolsSection(controller, hs) {
  if (!controller.hasToolsListTarget) return

  const hsId = hs?.id
  if (!hsId) {
    controller.toolsListTarget.innerHTML = ""
    return
  }

  const selected = ensureToolsSetForHotspot(controller, hsId)
  const tools = controller.availableTools || []

  if (!tools.length) {
    controller.toolsListTarget.innerHTML =
      `<div class="hs-empty">Nessun tool disponibile per questa scena.</div>`
    return
  }

  controller.toolsListTarget.innerHTML = ""

  const groups = new Map()

  tools.forEach((tool) => {
    const groupKey = String(tool.toolbox_id || "no_toolbar")
    const groupName = tool.toolbox_name || "Toolbar senza nome"

    if (!groups.has(groupKey)) {
      groups.set(groupKey, {
        name: groupName,
        tools: []
      })
    }

    groups.get(groupKey).tools.push(tool)
  })

  groups.forEach((group) => {
    const section = document.createElement("div")
    section.className = "hs-block"

    const head = document.createElement("div")
    head.className = "hs-block__head"
    head.innerHTML = `
      <div class="hs-block__meta">
        <span class="hs-block__badge">Toolbar</span>
        <div class="hs-block__title">${group.name}</div>
      </div>
    `

    const body = document.createElement("div")
    body.className = "hs-block__body"

    group.tools.forEach((t) => {
      const row = document.createElement("label")
      row.className = "hs-tool-row"

      const left = document.createElement("div")
      left.className = "hs-tool-row__left"

      const cb = document.createElement("input")
      cb.type = "checkbox"
      cb.className = "hs-tool-row__check"
      cb.dataset.toolId = String(t.id)
      cb.checked = selected.has(String(t.id))

      cb.addEventListener("change", () => {
        if (cb.checked) selected.add(String(t.id))
        else selected.delete(String(t.id))

        syncDuplicateToolCheckboxes(controller.toolsListTarget, t.id, cb.checked)
      })

      const iconWrap = document.createElement("div")
      iconWrap.className = "hs-tool-row__icon"

      if (t.image_url) {
        const img = document.createElement("img")
        img.src = t.image_url
        img.alt = t.name || "Tool"
        img.className = "hs-tool-row__img"
        iconWrap.appendChild(img)
      } else {
        iconWrap.innerHTML = `<span class="hs-tool-row__icon-fallback">🧰</span>`
      }

      const textWrap = document.createElement("div")
      textWrap.className = "hs-tool-row__text"

      const name = document.createElement("div")
      name.className = "hs-tool-row__name"
      name.textContent = t.name

      textWrap.appendChild(name)
      left.appendChild(cb)
      left.appendChild(iconWrap)
      left.appendChild(textWrap)
      row.appendChild(left)
      body.appendChild(row)
    })

    section.appendChild(head)
    section.appendChild(body)
    controller.toolsListTarget.appendChild(section)
  })

  syncAllDuplicateToolCheckboxes(controller.toolsListTarget, selected)
}

function syncDuplicateToolCheckboxes(container, toolId, checked) {
  container.querySelectorAll(`input[data-tool-id="${toolId}"]`).forEach((input) => {
    input.checked = checked
  })
}

function syncAllDuplicateToolCheckboxes(container, selected) {
  container.querySelectorAll("input[data-tool-id]").forEach((input) => {
    input.checked = selected.has(String(input.dataset.toolId))
  })
}